var map = {
	"./puzzle5.jpg": "8b44",
	"./puzzle5.mp3": "4796",
	"./puzzle5_1.jpg": "2496",
	"./puzzle5_1.mp3": "64d3",
	"./puzzle5_2.jpg": "d242",
	"./puzzle5_2.mp3": "ccfb",
	"./puzzle5_3.jpg": "6089",
	"./puzzle5_3.mp3": "3ccd",
	"./puzzle5_4.jpg": "aec4",
	"./puzzle5_4.mp3": "773a",
	"./puzzle5_5.jpg": "ccb6",
	"./puzzle5_5.mp3": "00f6",
	"./puzzle5_6.jpg": "bcdd",
	"./puzzle5_6.mp3": "ed11",
	"./puzzle5_7.jpg": "2193",
	"./puzzle5_7.mp3": "332b",
	"./puzzle5_8.jpg": "bf84",
	"./puzzle5_8.mp3": "9924",
	"./puzzle5_9.jpg": "c952",
	"./puzzle5_9.mp3": "1e34",
	"./puzzle5_all.jpg": "49ce",
	"./puzzle5_b1.png": "e844",
	"./puzzle5_b2.png": "63d3",
	"./puzzle5_b3.png": "5b9d",
	"./puzzle5_b4.png": "d7a0",
	"./puzzle5_b5.png": "49dc",
	"./puzzle5_b6.png": "db93",
	"./puzzle5_b7.png": "b67d",
	"./puzzle5_b8.png": "f9b4",
	"./puzzle5_b9.png": "a058"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "28f5";